'use strict';

(() => {
  let deliverySelected = false;
  let haisouDateInput;
  let haisouTimeInput;
  const checkoutBtn = document.querySelector('#checkout');
  const checkoutBtnAmazon = document.querySelector('.cart__dynamic-checkout-buttons');
  const cartItemsContainer = document.querySelector('#main-cart-items');

  function toggleCheckoutLock() {
    const requiredItem = document.querySelector('.delivery-required');

    if (!requiredItem) {
      checkoutBtn.classList.remove('selection-required');
      checkoutBtnAmazon.classList.remove('selection-required');
 
    }
    
    if (requiredItem && !deliverySelected) {
      checkoutBtn.classList.add('selection-required');
      checkoutBtnAmazon.classList.add('selection-required');
    }

    if (deliverySelected) {
      checkoutBtn.classList.remove('selection-required');
      checkoutBtnAmazon.classList.remove('selection-required');
    }
  }

  function haisouDateHandler() {
    if (document.querySelector('#haisoyamatoshippingdate')) {
      HaisoJquery('#haisoyamatoshippingdate')
        .datepicker()
        .on('input change', function (e) {
          deliverySelected = true;
          //BnK 030723
          $(this).removeClass("required");
          //BnK 030723
          toggleCheckoutLock();
        });
    }
    if (document.querySelector('#haisosagawashippingdate')) {
      HaisoJquery('#haisosagawashippingdate')
        .datepicker()
        .on('input change', function (e) {
          deliverySelected = true;
          //BnK 030723
          $(this).removeClass("required");
          //BnK 030723
          toggleCheckoutLock();
        });
    }
  }

  function setPlaceholders() {
    haisouDateInput.setAttribute('placeholder', '指定なし');

    if (haisouTimeInput) {
      const haisouTimePlaceholder = haisouTimeInput.querySelector(
        'option:nth-child(1)'
      );
      haisouTimePlaceholder.innerHTML = `<span>指定なし</span>`;
      haisouTimePlaceholder.setAttribute('hidden', '');
    }
  }

  function waitForElm(selector) {
    return new Promise(resolve => {
      if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector));
      }
      const observer = new MutationObserver(mutations => {
        if (document.querySelector(selector)) {
          resolve(document.querySelector(selector));
          observer.disconnect();
        }
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    });
  }

  waitForElm('#haisosm > p.cart-attribute__field').then(elm => {
    haisouDateInput =
      document.querySelector('#haisoyamatoshippingdate') ??
      document.querySelector('#haisosagawashippingdate');
    haisouTimeInput =
      document.querySelector('#haisoyamatoshippingtime') ??
      document.querySelector('#haisosagawashippingtime');

    haisouDateInput.setAttribute('form', 'cart');

    if (haisouTimeInput) {
      haisouTimeInput.setAttribute('form', 'cart');
    }

    haisouDateHandler();
    setPlaceholders();
    toggleCheckoutLock();
  });

  
  const watchCartItems = function () {
    const config = {
      childList: true,
      subtree: true,
    };

    const checkCartItems = function (mutationsList, observer) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          toggleCheckoutLock();
        }
        // observer.disconnect();
      }
    };
    const observer = new MutationObserver(checkCartItems);
    observer.observe(cartItemsContainer, config);
  };
  watchCartItems();
})();


//BnK 030723
  $("#checkout").on("click", function (e) {
    
    var deliveryRequired = $(".delivery-required");
    var deliveryDate = $("#haisosagawashippingtime");
    if(deliveryDate.length == 0) deliveryDate = $("#haisoShippingdate");

    if(deliveryRequired.length && deliveryDate.length){
      deliveryDate.removeClass("required");
      if(!deliveryDate.val()){
        deliveryDate.addClass("required");
        $('html,body').animate({
            scrollTop: $("#haisosm").offset().top - 120
        }, 300);
        return false;
      }
    }
  })

  var index = 0;
  var hasForm = false;
  var myIn = setInterval(function () {
    index++;
    if($("form[action='https://payments-fe.amazon.com/checkout/signin']").length){
      $("body .amazon-note").remove();
      //$("form[action='https://payments-fe.amazon.com/checkout/signin']").prepend('<div class="amazon-note">同意してAmazon Payでお支払いはこちら</div>')
      hasForm = true;
    }
    if(index == 10){
      clearInterval(myIn);
    }
  }, 1000);
  
  //BnK 030723